import bcrypt from 'bcryptjs';

export const encrypt = (value) => {
    const salt = bcrypt.genSaltSync(10);
    return bcrypt.hashSync(value, salt);
};

export const matchHash = (value, hash) => {
    return bcrypt.compareSync(value, hash);
};
